import React, {PropTypes} from 'react';
import ClearCartConfirmationContainer from '../shared/ClearCartConfirmationContainer.jsx';
import CartEntryListContainer from './CartEntryListContainer.jsx';
import CartVirtualEntryListContainer from './CartVirtualEntryListContainer.jsx';
import RosterConfirmationDialogContainer from '../manage/RosterConfirmationDialogContainer.jsx';
import EntryListContainer from './EntryListContainer.jsx';
import VirtualEntryListContainer from './VirtualEntryListContainer.jsx';
import RemoveVirtualEntriesConfirmationModalContainer from './RemoveVirtualEntriesConfirmationModalContainer.jsx';
import TeamOwnedVirtualEntryTrackerContainer from './TeamOwnedVirtualEntryTrackerContainer.jsx';
import {BOWLER} from '../../shared/constants';
import DisplayIf from 'shared/DisplayIf.jsx';

const CheckoutRoster = ({
  cart,
  entries,
  virtualEntries,
  rostersComplete,
  onClearCartClick,
  onContinueShoppingClick,
  onReviewClick,
  rosterMessage
}) => (
  <div>

    <ClearCartConfirmationContainer />
    <RemoveVirtualEntriesConfirmationModalContainer/>
    
    <DisplayIf condition={!!rosterMessage}>
      <div className="row">
        <div className="col-sm-12 animated fadeIn">
            <div className="alert alert-info text-center">
              { rosterMessage ? <p>{rosterMessage}</p> : null }
            </div>
        </div>
      </div>
    </DisplayIf>

    <div>
      {
        cart && cart.squads && cart.squads.length > 0
        ? 
          <div className="alert">
            <span>Please assign your team members before proceeding to payment:</span>
          </div>
        : null
      }
      <TeamOwnedVirtualEntryTrackerContainer />
      <CartEntryListContainer />
    </div>

    <div>
      {
        cart && cart.virtualEvents && cart.virtualEvents.length > 0 &&
         cart.virtualEvents.find(virtualEntry => virtualEntry.owner === BOWLER)
        ? 
          <div className="alert">
            <span>Please assign your virtual events before proceeding to payment:</span>
          </div>
        : null
      }
      <CartVirtualEntryListContainer />
    </div>

    <div className="text-right">
      <span>
        <button
          type="button"
          className="btn btn-link"
          onClick={onClearCartClick}
        >{'Clear My Cart'}</button>
        {' '}
        <button
          type="button"
          className="btn btn-link"
          onClick={onContinueShoppingClick}
        >{'Return to Calendar'}</button>
        {' '}
        <div className="display inline">
        <button
          type="button"
          className="btn btn-primary btn-lg"
          disabled={!rostersComplete}
          onClick={onReviewClick}
        ><i className="fa fa-shopping-cart" /> {`Review Cart`}</button>
        </div>
      </span>
    </div>

    <div>
        {
        (entries && entries.length > 0) || (virtualEntries && virtualEntries.length > 0)
        ? 
          <div className="alert">
            <span>Here are your existing (purchased) rosters:</span>
          </div>
        : null
      }
      <EntryListContainer />
      <VirtualEntryListContainer />
    </div>

    <RosterConfirmationDialogContainer />
  </div>
);

CheckoutRoster.propTypes = {
  cart: PropTypes.object,
  entries: PropTypes.arrayOf(PropTypes.object),
  virtualEntries: PropTypes.arrayOf(PropTypes.object),
  rostersComplete: PropTypes.bool,
  onClearCartClick: PropTypes.func,
  onContinueShoppingClick: PropTypes.func,
  onReviewClick: PropTypes.func
};

CheckoutRoster.defaultProps = {
  cart: {
    squads: [],
    virtualEvents: []
  },
  entries: [],
  virtualEntries: [],
  rostersComplete: false
};

export default CheckoutRoster;



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/CheckoutRoster.jsx